<!DOCTYPE html>
@if (loaded) {
  <div class="lifestyle-wrapper">
    <div class="page-title">
      <h2>{{ "Lifestyle.albums" | translate }}</h2>
      <p>{{ "Lifestyle.add_images" | translate }}</p>
    </div>
    @if (globalCategoryAlbumData$ |async; as segment) {
      <div class="main-categories">
        <ion-segment color="light" [(ngModel)]="category" (ionChange)="segmentChanged($event)">
          @for (key of categories; track key) {
            <ion-segment-button [value]="key">
              <ion-label>{{ segment[key]?.content?.[selectedLanguage]?.title }}</ion-label>
            </ion-segment-button>
          }
        </ion-segment>
      </div>
    }
    @if (getSocialFortuneLifeStyle$ |async; as allData) {
      <div class="cat-slider">
        <swiper [config]="catSliderOptions" class="swiper-inbox">
          @for (chipData of allData; track chipData) {
            <ng-template swiperSlide>
              @if (chipData?.content?.[selectedLanguage]?.title) {
                <ion-chip (click)="selectIonType(chipData?.content?.[selectedLanguage]?.title ,chipData?.content?.en?.title)"
                  [ngClass]="searchTerms === chipData?.content?.[selectedLanguage]?.title ? 'cat-chip': 'unactive'"
                  >
                  {{chipData?.content?.[selectedLanguage]?.title}}
                </ion-chip>
              }
            </ng-template>
          }
        </swiper>
      </div>
      <div class="filters-wrapper">
        <div class="left-bar">
          <!-- <a>
          <img src="../../../../../assets/icon/sgrid.svg" alt="" (click)="gridChange = !gridChange">
        </a>
        <a>
          <img src="../../../../../assets/icon/smgrid.svg" alt="" (click)="gridChange = !gridChange">
        </a> -->
        @if (mine == true) {
          <p><span>{{mineImageData?.images?.length}}</span>/{{mineImageData?.limit}}</p>
        }
        <!-- <p *ngIf="new == true && !isliked "><span>{{unsplashApiImages?.length}}</span>/{{searchImages?.results?.length}}
      </p> -->
      @if (new == true && isliked ) {
        <p>
          <span>{{likedImages?.images?.length}}</span>/{{searchImages?.results?.length}}
        </p>
      }
    </div>
    <div class="grid-title">{{searchTerms}}</div>
    <div class="right-bar">
      <div class="group-btn">
        <button class="" [ngClass]="{'active':mine == true }" (click)="mineNew('mine')">{{ "Lifestyle.mine" |
        translate }}</button>
        <button class="" [ngClass]="{ 'active':new == true}" (click)="mineNew('new')">{{ "Lifestyle.new" | translate
        }}</button>
      </div>
    </div>
  </div>
  @if (mine == true) {
    <div class="sort-wrapper">
      <mat-form-field appearance="fill">
        <mat-label>{{ "Lifestyle.filter" | translate }}</mat-label>
        <mat-select [(value)]="selectedValue" (selectionChange)="minFilteredOption($event.value)">
          @for (option of sort; track option) {
            <mat-option [value]="option.value">{{ option.viewValue }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="pic-wrapper">
      @if (!mineImages || mineImages?.length == 0) {
        <div class="empty-gallery">
          <div class="empty-data">
            <img src="../../../../../assets/icon/image-outline.svg" alt="">
            <p> {{ "Lifestyle.no_images" | translate }}</p>
          </div>
        </div>
      }
      <div class="gallery" #mineGallery (scroll)="onScroll($event)">
        <!-- mineImages  -->
        <div class="fl-unsplash">
          @for (images of mineVisibleImages; track images) {
            <div class="fl-images">
              <img [src]="images?.image_url" alt="mine gallery"
                (click)="unsplashPhotoPopup(images?.image_url,selectedId,category,images?.liked)">
              </div>
            }
          </div>
        </div>
      </div>
    }
    @if (new == true) {
      <div class="sort-wrapper">
        <mat-form-field appearance="fill">
          <mat-label>{{ "Lifestyle.filter" | translate }}</mat-label>
          <mat-select [(value)]="selectedLikedValue" (selectionChange)="filteredOption($event.value,selectedId)">
            @for (option of sortBy; track option) {
              <mat-option [value]="option.value">{{ option.viewValue }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div [ngClass]="likedImages?.images?.length === 0 && isLiked === true ? 'display-none' :'gallery'" #newGallery (scroll)="onScroll($event)">
        <!-- Default images -->
        @if (!isLiked && ApiImages) {
          <div class="fl-unsplash">
            @for (images of newVisibleImages; track images) {
              <div class="fl-images">
                <img [src]="images" alt="" (click)="ownedPhotoPopup(images,selectedId,searchTerms,category,mineImageData)">
              </div>
            }
          </div>
        }
        <!-- All images -->
        @if (allImages) {
          <div class="fl-unsplash">
            @for (images of unsplashApiImages; track images) {
              <div class="fl-images">
                <img [src]="images" alt="" (click)="ownedPhotoPopup(images,selectedId,searchTerms,category,mineImageData)">
              </div>
            }
          </div>
        }
        <!-- isLiked images -->
        @if (isLiked) {
          <div class="fl-unsplash">
            @for (img of likedImages?.images; track img) {
              <div class="fl-images">
                <img [src]="img" alt="" (click)="ownedPhotoPopup(img,selectedId,searchTerms,category,mineImageData)">
              </div>
            }
          </div>
        }
      </div>
      <!-- This is for empty -->
      <div [ngClass]="likedImages?.images?.length === 0 && isLiked === true ? 'empty-gallery' :'display-none'">
        <div class="empty-data">
          <img src="../../../../../assets/icon/image-outline.svg" alt="">
          <p> {{ "Lifestyle.no_images" | translate }}</p>
        </div>
      </div>
    }
  }
</div>
} @else {
  <app-in-progress-animation type="lifestyle-cards-skeleton"></app-in-progress-animation>
}

